import React from 'react';

function KfhLogoSmall({ ...rest }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 69 28" {...rest}>
      <path
        fill="#fff"
        d="M30.23 15.367h2.354V8.33h5.483V6.605h-5.483V1.688h6.38V0H30.23v15.367ZM26.702 0h-2.804l-6.193 6.753V0h-2.33v15.367h2.33V7.862l6.617 7.505h2.99L19.9 7.172 26.69 0h.013Zm24.871 0v6.506h-6.978V0h-2.218v15.367h2.218v-7.11h6.978v7.11h2.218V0h-2.218Z"
      />
      <path fill="#5BA563" fillRule="evenodd" d="M51.526 28H68.46v-6.821H51.526V28Z" clipRule="evenodd" />
      <path fill="#489FE2" fillRule="evenodd" d="M34.578 28h16.935v-6.821H34.578V28Z" clipRule="evenodd" />
      <path fill="#634D94" fillRule="evenodd" d="M17.643 28h16.935v-6.821H17.643V28Z" clipRule="evenodd" />
      <path fill="#E8AA48" fillRule="evenodd" d="M.708 28h16.935v-6.821H.708V28Z" clipRule="evenodd" />
    </svg>
  );
}

export default KfhLogoSmall;
